module.exports = __webpack_public_path__ + "static/img/8.3e9a453.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/8.png
// module id = t6pP
// module chunks = 0